/**
 * 访客须知：仅使用 sessionStorage，关闭标签页后需重新阅读。
 * 避免 localStorage 长期为「已读」导致再次打开首页时跳过须知。
 */
const NOTICE_SESSION_KEY = 'visitor_notice_ok_v2'

const HOST_COMPANY_SESSION_KEY = 'visitor_host_company'

const LEGACY_LOCAL_KEY = 'noticeConfirmed'

/**
 * 须知通过后选择的访问公司，须与后端 workflow_info.company_name 一致，写入登记 visitor_register.visited_company
 */
export function setHostCompanyInSession (companyName) {
  try {
    if (companyName == null || String(companyName).trim() === '') {
      window.sessionStorage.removeItem(HOST_COMPANY_SESSION_KEY)
      return
    }
    window.sessionStorage.setItem(HOST_COMPANY_SESSION_KEY, String(companyName).trim())
  } catch (e) {
    /* ignore */
  }
}

export function getHostCompanyFromSession () {
  try {
    const v = window.sessionStorage.getItem(HOST_COMPANY_SESSION_KEY)
    return v ? String(v).trim() : ''
  } catch (e) {
    return ''
  }
}

export function clearHostCompanyFromSession () {
  try {
    window.sessionStorage.removeItem(HOST_COMPANY_SESSION_KEY)
  } catch (e) {
    /* ignore */
  }
}

export function isVisitorNoticeOkInSession () {
  try {
    return window.sessionStorage.getItem(NOTICE_SESSION_KEY) === '1'
  } catch (e) {
    return false
  }
}

export function setVisitorNoticeOkInSession () {
  try {
    window.sessionStorage.setItem(NOTICE_SESSION_KEY, '1')
  } catch (e) {
    /* ignore */
  }
}

export function clearVisitorNoticeSession () {
  clearHostCompanyFromSession()
  try {
    window.sessionStorage.removeItem(NOTICE_SESSION_KEY)
  } catch (e) {
    /* ignore */
  }
  try {
    window.localStorage.removeItem(LEGACY_LOCAL_KEY)
  } catch (e) {
    /* ignore */
  }
}

/** 应用启动时淘汰旧版 localStorage 标记，仅保留本次会话的 session 判定 */
export function clearLegacyVisitorNoticeLocalStorage () {
  try {
    window.localStorage.removeItem(LEGACY_LOCAL_KEY)
  } catch (e) {
    /* ignore */
  }
}
